import axios from 'axios'
import {Message, MessageBox} from "element-ui";
import store from '../store';
import {getToken, removeToken} from "./auth";

// 创建axios实例
export const service = axios.create({
    baseURL: process.env.API_BASE_URL,
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 300000,
})

//专门用于下载的实例
export const downloadService = axios.create({
  baseURL: process.env.API_BASE_URL,
  // timeout: 20 * 1000,
});

// request拦截器
service.interceptors.request.use(config => {
  let token  = getToken();
    if (token) {
        config.headers['elevator-token'] = token;
    }else {
      // console.log('no token');
    }
    return config
}, error => {
    console.log(error) // for debug
    Promise.reject(error)
})

// response拦截器
service.interceptors.response.use(
    response => {
        if (!response.data.success){
          let code = response.data.code;
          if (code==='401'){
              removeToken();
              MessageBox("会话已过期，请重新登录",'',{
                confirmButtonText:'确定',
                showClose:false
              }).then(res=>{
                  window.location.reload();
              }).catch(()=>{
                  console.log('click cancel');
              })
          } else {
            console.log(response);
            // Message.error(response.data);
          }
        }
        return response;
    },
    error => {
        console.log('err' + error) // for debug
        Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)




// WEBPACK FOOTER //
// ./src/utils/axios.js